import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// import Inpatientdepartment from '@/view/departmentintro/inpatientdepartment/inpatientdepartment.vue'
 const router = new Router({
  scrollBehavior: () => ({y:0}),
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import("@/view/home/home")
    },
    // 简介
    {
      path: '/hosintro',
      name: 'hosintro',
      component: () => import("@/view/hosintro/hosintro")
    },
    {
      path: '/hosnav',
      name: 'hosnav',
      component: () => import("@/view/hosintro/hosnav/hosnav")
    },
    
    //专家
    {
      path: '/experts',
      name: 'experts',
      component: () => import("@/view/experts/experts")
    },
    {
      path: '/expertsdetail',
      name: 'expertsdetail',
      component: () => import("@/view/experts/expertsdetail")
    },
    {
      path: '/communication',
      name: 'communication',
      component: () => import("@/view/communication/communication")
    },
    //科室
    {
      path: '/departmentintro',
      name: 'departmentintro',
      component: () => import("@/view/departmentintro/departmentintro")
    },
    {
      path: '/firstdepart',
      name: 'firstdepart',
      component: () => import("@/view/departmentintro/firstdepart")
    },
    // {
    //   path: '/outpatientdepartment',
    //   name: 'outpatientdepartment',
    //   component: () => import("@/view/departmentintro/outpatientdepartment/outpatientdepartment")
    // },
    // {
    //   path: '/inpatientdepartment',
    //   name: 'inpatientdepartment',
    //   component: Inpatientdepartment
    // },
    // {
    //   path: '/otherdepartment',
    //   name: 'otherdepartment',
    //   component: () => import("@/view/departmentintro/otherdepartment/otherdepartment")
    // },
    {
      path: '/departmentdetail',
      name: 'departmentdetail',
      component: () => import("@/view/departmentintro/departmentdetail")
    },
    //动态
    {
      path: '/hosdynamic',
      name: 'hosdynamic',
      component: () => import("@/view/hosdynamic/hosdynamic")
    },
     {
      path: '/notice',
      name: 'notice',
      component: () => import("@/view/hosdynamic/notice/notice")
    },
    {
      path: '/news',
      name: 'news',
      component: () => import("@/view/hosdynamic/news")
    },
    {
      path: '/newscenter',
      name: 'newscenter',
      component: () => import("@/view/hosdynamic/newscenter/newscenter")
    },
    {
      path: '/media',
      name: 'media',
      component: () => import("@/view/hosdynamic/media/media")
    },
    {
      path: '/opentender',
      name: 'opentender',
      component: () => import("@/view/hosdynamic/opentender/opentender")
    },
    {
      path: '/tenderdetail',
      name: 'tenderdetail',
      component: () => import("@/view/hosdynamic/opentender/tenderdetail")
    },
    {
      path: '/newsdetail',
      name: 'newsdetail',
      component: () => import("@/view/hosdynamic/newsdetail")
    },
    //加入我们
    {
      path: '/joinus',
      name: 'joinus',
      component: () => import("@/view/joinus/joinus")
    },
    {
      path: '/jobdetail',
      name: 'jobdetail',
      component: () => import("@/view/joinus/jobdetail")
    },
    //预约
    {
      path: '/appointment',
      name: 'appointment',
      component: () => import("@/view/appointment/appointment")
    },


  ]
})

// router.beforeEach(()=>{
  
// })

export default router


// WEBPACK FOOTER //
// ./src/router/index.js